import { StorefrontOutlined } from "@mui/icons-material";
import {
  alpha,
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import CustomDialog from "Components/CustomDialog/CustomDialog";
import { useEcommerceDataNotice } from "features/project/hooks/useEcommerceDataNotice";

function EcommerceDataNoticeDialog() {
  const { shouldShow, dismiss } = useEcommerceDataNotice();

  return (
    <CustomDialog
      open={shouldShow}
      isConfirmation
      showClose={false}
      disableEscapeKeyDown
      fullWidth
      maxWidth="sm"
    >
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Box
            sx={(theme) => ({
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: 64,
              height: 64,
              borderRadius: "50%",
              mb: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              color: theme.palette.primary.main,
            })}
          >
            <StorefrontOutlined sx={{ fontSize: 32 }} />
          </Box>
          <Typography variant="h6" fontWeight={700}>
            Your store data is syncing
          </Typography>
        </Box>
        <DialogContentText component="div">
          <p>
            We're backfilling your historical orders from your store. This can
            take a few minutes depending on how much order history you have.
          </p>
          <p>
            Traffic and session data isn't available yet - it will appear once
            the tracking pixel starts collecting visits on your store.
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button color="primary" fullWidth size="small" onClick={dismiss}>
          OK
        </Button>
      </DialogActions>
    </CustomDialog>
  );
}

export default EcommerceDataNoticeDialog;
